import { connect } from 'react-redux';
import {
  fetchGuestFiles,
  deleteGuestFile
} from '../../../redux/Guest/sagas/routines';
import {
  getFetching,
  getFetched,
  getDeleting,
  getDeleted,
  getOrder
} from '../../../redux/Guest/selectors/file';
import {
  clearGuestFiles,
  guestFilesOnChangePage,
  guestFilesOnChangeOrder
} from '../../../redux/Guest/actions/file';
import {
  getPaginationLoadedPages,
  getPaginationWithoutPages,
  getPaginationQueryOptions,
  getCurrentPageFiles
} from '../../../redux/Guest/selectors/file/pagination';
import { getGuestFileSearchQuery } from '../../../redux/Guest/selectors/components/file-search';
import paginationAndSearchQuery from '../../../helpers/paginationAndSearchQuery';
import GuestFileList from '../../../components/guest/FileList';
import orderList from '../../../helpers/orderList';

function mapStateToProps(state) {
  const paginationQuery = getPaginationQueryOptions(state);
  const searchQuery = getGuestFileSearchQuery(state);
  const order = getOrder(state);
  return {
    files: orderList(order, getCurrentPageFiles(state)),
    query: { ...paginationAndSearchQuery(paginationQuery, searchQuery), order },
    loadedPages: getPaginationLoadedPages(state),
    pagination: getPaginationWithoutPages(state),
    isFetching: getFetching(state),
    isFetched: getFetched(state),
    isDeleting: getDeleting(state),
    isDeleted: getDeleted(state)
  };
}

function mapDispatchToProps(dispatch, { guestId }) {
  return {
    onInit: () => {
      dispatch(fetchGuestFiles({ guestId }));
    },
    onDelete: fileId => {
      dispatch(deleteGuestFile(fileId));
    },
    onChangePage: (query, isPageLoaded) => {
      const { page } = query;
      if (!isPageLoaded) dispatch(fetchGuestFiles({ ...query, guestId }));
      else dispatch(guestFilesOnChangePage(page));
    },
    onChangeLimit: query => {
      dispatch(clearGuestFiles());
      dispatch(fetchGuestFiles({ ...query, guestId }));
    },
    onSort: (sortBy, sortOrder, query) => {
      const order = `${sortBy}:${sortOrder}`;
      dispatch(clearGuestFiles());
      dispatch(fetchGuestFiles({ ...query, order, guestId }));
      dispatch(guestFilesOnChangeOrder(order));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GuestFileList);
